export const BASE_ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    SIGNUP: '/signup',
    INVESTOR: '/investor',
    COMPANY: '/company',

    RESET_PASSWORD: '/reset-password',
    ADDITIONAL_DETAILS: '/additional-details',
    CIBIL_VERIFICATION: '/cibilVerification',
    NOT_FOUND: '/not-found',
    MAGIC_LINK: '/ml',
    PREVIEW_EMAIL: '/preview-email',
};

export const INVESTOR_ROUTES = {
    LOGIN: '/investor/login',
    SIGNUP: '/investor/signup',
    SUMMON_AICA: '/investor/summon-aica',
    PARTNER_SIGNUP: '/investor/partner-signup',
    PARTNER_SIGNUP_ADDITIONAL_DETAILS: '/investor/partner-signup/additional-details',

    APP: '/investor/app',
    APP_WATCH: '/investor/app/watch',
    APP_SCAN: '/investor/app/scan',
    APP_TRACK: '/investor/app/track',
    PORTFOLIO: 'portfolio',
    PORTFOLIO_DETAILS: 'portfolio/:id',
    DATA_ROOM_DETAILS: 'data-room/:id',
    DATA_ROOM: 'data-room',
    MANAGE_USER: 'manage-user',
    ALL_USERS: 'all-users',
    DEBT_PRODUCTS: 'debt-products/:id',
    MANAGE_ELIGIBILITY: 'manage-eligibility',
    PDF_REPORT: 'pdf-report/:id',
    NOTIFICATIONS: 'notifications',
    COMPANY_DEALS: 'company-deals/:id',

    //NEW TABS
    SCAN: 'scan',
    WATCH: 'watch',
    TRACK: 'track',
    DEALS: 'deals',
    MONITOR: 'monitor',

    // Reports
    REPORTS: 'reports',
    REPORTS_DETAILS: 'reports/:id',
    REPORTS_EDITOR: 'reports/:id/editor',

    PLATFORM_CONFIG: 'platform-config',
};

// Shared route builder for the investor portfolio-detail screen — reused by
// mobile call sites that navigate there (LeadCardList, DealsList).
export const portfolioDetailPath = (id: string) => `/investor/app/portfolio/${id}`;

export const LENDER_ROUTES = {
    APP: '/lender/app',
    MANAGE_ELIGIBILITY: 'manage-eligibility',
    DEALS: 'deals',
};

export const MAGIC_SIGN_PORTAL_ROUTE = '/sign/:token';
export const MAGIC_SIGN_PORTAL_PATH = (token: string) => `/sign/${token}`;

export const COMPANY_ROUTES = {
    UPLOAD: '/company/upload',
    OFFERS: '/company/offers',
    DEALS: '/company/deals',
    DEBT_PRODUCTS: '/company/debt-products/:id',
    DEBT_PRODUCTS_WITH_ID: (id: string) => `/company/debt-products/${id}`,
    PORTFOLIO: '/company/portfolio',
    PORTFOLIO_DETAILS: '/company/portfolio/:id',
};

// Company-role counterpart of `portfolioDetailPath` — same shared Overview screen
// (`Dashboard`), mounted under `/company/portfolio/:id` for company/borrower sessions
// instead of `/investor/app/portfolio/:id`. Used by mobile call sites (DealsList) whose
// card tap is reachable by both investor and company accounts.
export const companyPortfolioDetailPath = (id: string) => `${COMPANY_ROUTES.PORTFOLIO}/${id}`;
